import React, { useState, useEffect } from 'react';
import styles from './ClientTypes.module.css';

const ClientTypeForm = ({ clientType, onSubmit, onCancel, loading }) => {
    const [formData, setFormData] = useState({
        clientType: '',
        clientTypeDescription: ''
    });
    
    const [errors, setErrors] = useState({});

    // Initialize form with existing data when editing
    useEffect(() => {
        if (clientType) {
            setFormData({
                clientType: clientType.clientType || '',
                clientTypeDescription: clientType.clientTypeDescription || ''
            });
        }
    }, [clientType]);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.clientType) {
            newErrors.clientType = 'Client type name is required';
        }

        if (formData.clientType.length > 50) {
            newErrors.clientType = 'Client type name cannot exceed 50 characters';
        }

        if (formData.clientTypeDescription && formData.clientTypeDescription.length > 254) {
            newErrors.clientTypeDescription = 'Description cannot exceed 254 characters';
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validateForm()) {
            onSubmit(formData);
        }
    };

    return (
        <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.formHeader}>
                <h3>{clientType ? 'Edit Client Type' : 'Add New Client Type'}</h3>
            </div>
            <div className={styles.formBody}>
                <div className={styles.field}>
                    <label className={styles.label}>Client Type Name *</label>
                    <input
                        type="text"
                        value={formData.clientType}
                        onChange={(e) => setFormData({
                            ...formData,
                            clientType: e.target.value
                        })}
                        className={`${styles.input} ${errors.clientType ? styles.inputError : ''}`}
                        placeholder="Enter client type name"
                        maxLength={50}
                        disabled={loading}
                    />
                    {errors.clientType && (
                        <span className={styles.errorText}>{errors.clientType}</span>
                    )}
                    <small className={styles.hint}>
                        {formData.clientType.length}/50 characters
                    </small>
                </div>
                <div className={styles.field}>
                    <label className={styles.label}>Description</label>
                    <textarea
                        value={formData.clientTypeDescription}
                        onChange={(e) => setFormData({
                            ...formData,
                            clientTypeDescription: e.target.value
                        })}
                        className={`${styles.textarea} ${errors.clientTypeDescription ? styles.inputError : ''}`}
                        placeholder="Enter description (optional)"
                        maxLength={254}
                        rows={4}
                        disabled={loading}
                    />
                    {errors.clientTypeDescription && (
                        <span className={styles.errorText}>{errors.clientTypeDescription}</span>
                    )}
                    <small className={styles.hint}>
                        {formData.clientTypeDescription.length}/254 characters
                    </small>
                </div>
            </div>
            <div className={styles.formFooter}>
                <button 
                    type="button"
                    onClick={onCancel}
                    className={styles.cancelButton}
                    disabled={loading}
                >
                    Cancel
                </button>
                <button 
                    type="submit"
                    className={styles.submitButton}
                    disabled={loading}
                >
                    {loading ? 'Saving...' : (clientType ? 'Update' : 'Create')}
                </button>
            </div>
        </form>
    );
};

export default ClientTypeForm;
